import {LevelIndicator} from './levelIndicatorsFor';

/**
 * Turns the ordered indicator list from `levelIndicatorsFor` into named flags,
 * so call sites branch on `hasFuel` / `hasBattery` instead of spelling the indicator literals.
 */
export const getLevelIndicatorFlags = (levelIndicators: LevelIndicator[]) => ({
  hasFuel: levelIndicators.includes('fuel'),
  hasBattery: levelIndicators.includes('battery'),
});
